import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { ref } from "vue";
import { db } from "@/database/db";
import { VesselItemPayload, VesselItemResponse } from "@/types/interface/item-vessel";

// const loginInfo = ref();
// const stringLoginInfo = await db.storage.get("login-info")!;
// loginInfo.value = stringLoginInfo?.data;

async function create(payload: VesselItemPayload) {
  return await http.post<APIResponse<VesselItemResponse>>("vessel-item-quantity/create", payload);
}

async function update(idVesselItem = '', payload: VesselItemPayload) {
  return await http.patch<APIResponse<VesselItemResponse>>(`vessel-item-quantity/update?id=${idVesselItem}`, payload);
}

async function getList(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  // if (loginInfo?.value?.job?.id != undefined){
  //   queryParam = queryParam + '&job_id=' + loginInfo?.value?.job?.id;
  // }
  return await http.get<APIResponse<VesselItemResponse>>(`vessel-item-quantity?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function find(idVesselItem = "") {
  return await http.get<APIResponse<VesselItemResponse>>(`vessel-item-quantity/detail?id=${idVesselItem}`);
}

async function specificItem(queryParams: string) {
  return await http.get<APIResponse<VesselItemResponse>>(`vessel-item-quantity/specific-detail${queryParams}`);
}

async function remove(idVesselItem = "") {
  return await http.delete<APIResponse<VesselItemResponse>>(`vessel-item-quantity/delete?id=${idVesselItem}`);
}

export default {
  create,
  update,
  getList,
  find,
  remove,
  specificItem
};